import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\"><title>icon-facebook</title><path d=\"M218.886 196.631h-34.155v55.754h34.155v163.782h65.681V251.688h45.823l4.879-55.057h-50.702V165.27c0-12.981 2.614-18.121 15.158-18.121h35.543V90h-45.474c-48.873 0-70.908 21.517-70.908 62.725v43.906z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol